module.exports = {
    tag: 'poise',
    quality: 0.4,
    physicalResil: 2,
};